import axios from "axios"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardImg,
  Col,
  Input,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap"
import { api} from "../../../utils/variables"
import { buildKeywordSearchParams, KEYWORD_SEARCH_PATH, normalizeSearchGames } from "../../../utils/keywordSearch"
import NavTabs from "../../NavTabs"
import { usePlatforms } from "../../../contexts/PlatformsContext"
import { Search, Info, Gamepad2 } from "lucide-react";

export default function AppSearchModal({
  modaltoggle,
  togglemodal,
  onAppSelect,
  alreadySelectedApps,
  type,
}) {
  const { getActivePlatforms, getPlatformDisplayName } = usePlatforms();
  const [inputValue, setInputValue] = useState("")
  const [searchValue, setsearchValue] = useState("")
  const [filteredApps, setCatFilteredApps] = useState([])
  const [dataAction, setDataAction] = useState("loading")
  const [games, setgamesresponse] = useState([])
  const [filteredGames, setFilteredGames] = useState([])
  // Default to "all" for AppSearchModal
  const [selectedPlatform, changePlatform] = useState("all")
  const [loading, setLoading] = useState(false)

  const modalBodyRef = useRef(null)

  const handleKeyDown = event => {
    if (event.key === "Enter") {
      handleSearch()
    }
  }

  const fetchSearchResult = async value => {
    try {
      const searchParams = new URLSearchParams(buildKeywordSearchParams(value))
      const url = `${api}${KEYWORD_SEARCH_PATH}?${searchParams.toString()}`
      let res = await axios.get(url, {})
      setDataAction(res.data.action)
      let pollCount = 0
      while (res.data.action.toLowerCase() !== "display" || ((!res.data.games || res.data.games.length === 0) && pollCount < 3)) {
        if (res.data.action.toLowerCase() === "display" && (!res.data.games || res.data.games.length === 0)) {
          pollCount++
        }
        await new Promise(resolve => setTimeout(resolve, 3000))
        res = await axios.get(url, {})
        setDataAction(res.data.action)
        if (res.data.action.toLowerCase() === "display" && res.data.games && res.data.games.length > 0) {
          break;
        }
      }
      const finalGames = normalizeSearchGames(res.data.games || [])
      setCatFilteredApps(finalGames)
      setgamesresponse(finalGames)
      setFilteredGames(finalGames)
      sessionStorage.setItem("filteredApps", JSON.stringify(finalGames))
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const handleSearch = async () => {
    if (!inputValue) return
    setLoading(true)
    await fetchSearchResult(inputValue)
    await setsearchValue(inputValue)
    setLoading(false)
  }

  useEffect(() => {
    const platformFilteredGames =
      selectedPlatform !== "all"
        ? games.filter(game => game.platform === selectedPlatform)
        : games
    setFilteredGames(platformFilteredGames)
  }, [selectedPlatform, games])

  return (
    <Modal
      isOpen={modaltoggle}
      toggle={() => {
        togglemodal()
      }}
      centered
      size="lg"
      className="premium-app-search-modal"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {type === "Category" ? "Select an App to Track Category" : "Select an App"}
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={togglemodal}
          aria-label="Close"
        ></button>
      </div>
      <ModalBody
        style={{
          maxHeight: "80vh",
          minHeight: "40vh",
          padding: "24px",
          overflowY: "auto",
          background: "#1a1b24"
        }}
      >
        <div ref={modalBodyRef}>
          <div className="d-flex flex-wrap justify-content-between gap-2">
            <Col>
              <div
                className="d-flex flex-wrap gap-3"
                style={{ position: "sticky", top: 0, zIndex: 10, background: "#1a1b24", paddingBottom: "10px" }}
              >
                <div className="search-box chat-search-box position-relative flex-grow-1">
                  <Input
                    type="text"
                    className="form-control"
                    style={{
                      background: "rgba(255, 255, 255, 0.05)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "12px",
                      color: "#fff",
                      padding: "12px 16px 12px 40px",
                    }}
                    placeholder="Search apps by name or paste a URL..."
                    value={inputValue}
                    onChange={e => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <Search
                    size={18}
                    color="rgba(255, 255, 255, 0.4)"
                    style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)" }}
                  />
                </div>
                <Button
                  style={{
                    background: "#F6255A",
                    border: "none",
                    borderRadius: "12px",
                    padding: "0 24px",
                    fontWeight: "600",
                    boxShadow: "0 4px 12px rgba(246, 37, 90, 0.2)",
                  }}
                  onClick={handleSearch}
                >
                  Search
                </Button>
              </div>
            </Col>
          </div>

          <Col className="mt-4">
            {alreadySelectedApps.length > 0 && (
              <p style={{ color: "rgba(255, 255, 255, 0.5)", fontSize: "14px", fontWeight: "600", marginBottom: "16px" }}>
                Already Tracked
              </p>
            )}

            {alreadySelectedApps.map((val, index) => (
              <Row className="pb-2" key={index}>
                <Col lg={12}>
                  <Card
                    style={{
                      background: "rgba(255, 255, 255, 0.03)",
                      border: "1px solid rgba(255, 255, 255, 0.05)",
                      borderRadius: "16px",
                      overflow: "hidden",
                    }}
                  >
                    <Row className="g-0 align-items-center">
                      <Col xs={4} md={3}>
                        <CardImg
                          className="img-fluid p-2"
                          src={val?.image_url || "https://via.placeholder.com/50"}
                          alt={val?.name}
                          style={{
                            height: "80px",
                            width: "100%",
                            objectFit: "contain",
                            borderRadius: "12px",
                            background: "rgba(0,0,0,0.2)"
                          }}
                        />
                      </Col>
                      <Col xs={8} md={9}>
                        <CardBody className="py-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <div style={{ minWidth: 0, flex: 1 }}>
                              <b className="text-white d-block text-truncate" style={{ fontSize: "15px" }}>
                                {val?.name || "App Name"}
                              </b>
                              <span style={{ color: "rgba(255, 255, 255, 0.4)", fontSize: "12px" }}>
                                {val?.platform ? getPlatformDisplayName(val.platform) : "Unknown"}
                              </span>
                            </div>
                            <Button
                              size="sm"
                              style={{
                                background: "rgba(74, 222, 128, 0.1)",
                                color: "#4ade80",
                                border: "1px solid rgba(74, 222, 128, 0.2)",
                                borderRadius: "8px",
                                padding: "6px 16px",
                                fontWeight: "600",
                              }}
                              onClick={() => onAppSelect(inputValue, val)}
                            >
                              View
                            </Button>
                          </div>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            ))}

            <div style={{ marginTop: "24px" }}>
              <p style={{ color: "rgba(255, 255, 255, 0.5)", fontSize: "14px", fontWeight: "600", marginBottom: "16px" }}>
                Search Results
              </p>

              {filteredGames.length === 0 ? (
                <div className="text-center py-5" style={{
                  background: "rgba(255, 255, 255, 0.02)",
                  borderRadius: "16px",
                  border: "1px dashed rgba(255, 255, 255, 0.1)",
                }}>
                  <div style={{
                    width: "56px",
                    height: "56px",
                    background: "rgba(246, 37, 90, 0.1)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px"
                  }}>
                    <Search size={24} color="#F6255A" />
                  </div>
                  <h6 style={{ color: "#fff", fontWeight: 600, marginBottom: "8px" }}>
                    {searchValue ? "No Results Found" : "Search Apps & Games"}
                  </h6>
                  <p style={{ color: "rgba(255, 255, 255, 0.5)", fontSize: "13px", maxWidth: "280px", margin: "0 auto" }}>
                    {searchValue
                      ? `We couldn't find any results for "${searchValue}"`
                      : "Type a name above to search and track your favorite apps."
                    }
                  </p>
                </div>
              ) : (
                filteredGames.map((val, index) => {
                  const isTracked = alreadySelectedApps.some(
                    app => app.name === val.name
                  )
                  return (
                    <Row className="pb-2" key={index}>
                      <Col lg={12}>
                        <Card
                          style={{
                            background: "rgba(255, 255, 255, 0.03)",
                            border: "1px solid rgba(255, 255, 255, 0.05)",
                            borderRadius: "16px",
                            overflow: "hidden",
                            transition: "all 0.2s ease"
                          }}
                        >
                          <Row className="g-0 align-items-center">
                            <Col xs={4} md={3}>
                              <CardImg
                                className="img-fluid p-2"
                                src={val?.image_url || "https://via.placeholder.com/50"}
                                alt={val?.name}
                                style={{
                                  height: "80px",
                                  width: "100%",
                                  objectFit: "contain",
                                  borderRadius: "12px",
                                  background: "rgba(0,0,0,0.2)"
                                }}
                              />
                            </Col>
                            <Col xs={8} md={9}>
                              <CardBody className="py-2">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div style={{ minWidth: 0, flex: 1 }}>
                                    <b className="text-white d-block text-truncate" style={{ fontSize: "15px" }}>
                                      {val?.name || "App Name"}
                                    </b>
                                    <span style={{ color: "rgba(255, 255, 255, 0.4)", fontSize: "12px" }}>
                                      {val?.platform ? getPlatformDisplayName(val.platform) : "Unknown"}
                                    </span>
                                  </div>

                                  {isTracked ? (
                                    <Button
                                      size="sm"
                                      style={{
                                        background: "rgba(74, 222, 128, 0.1)",
                                        color: "#4ade80",
                                        border: "1px solid rgba(74, 222, 128, 0.2)",
                                        borderRadius: "8px",
                                        padding: "6px 16px",
                                        fontWeight: "600",
                                      }}
                                      onClick={() => onAppSelect(inputValue, val)}
                                    >
                                      View
                                    </Button>
                                  ) : (
                                    <Button
                                      size="sm"
                                      style={{
                                        background: "rgba(246, 37, 90, 0.1)",
                                        color: "#F6255A",
                                        border: "1px solid rgba(246, 37, 90, 0.2)",
                                        borderRadius: "8px",
                                        padding: "6px 16px",
                                        fontWeight: "600",
                                      }}
                                      onClick={() => onAppSelect(inputValue, val)}
                                    >
                                      Select
                                    </Button>
                                  )}
                                </div>
                              </CardBody>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  )
                })
              )}
            </div>
          </Col>
        </div>
        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              zIndex: 9999,
            }}
          >
            <Spinner color="primary" />
          </div>
        )}
      </ModalBody>
      <style>{`
        .premium-app-search-modal .modal-content {
          background: #1a1b24 !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          border-radius: 20px !important;
          overflow: hidden;
        }
        .premium-app-search-modal .modal-header {
          border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
          padding: 20px 24px !important;
          background: #1a1b24 !important;
        }
        .premium-app-search-modal .modal-header .modal-title {
          color: #fff !important;
          font-weight: 600 !important;
          font-size: 18px !important;
        }
        .premium-app-search-modal .btn-close {
          filter: invert(1) !important;
          opacity: 0.6 !important;
        }
        .premium-app-search-modal .btn-close:hover {
          opacity: 1 !important;
        }
      `}</style>
    </Modal>
  )
}
